import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Box, Typography, Paper } from '@mui/material';

function PrivacyPolicy() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const handleAccept = () => {
    navigate('/confirmar', { state: { email } });
  };

  return (
    <div className="animation-container bg" style={{ minHeight: '100vh', padding: '1.5rem' }}>
      <Box sx={{ maxWidth: 720, margin: '0 auto' }}>
        <Paper elevation={1} sx={{ p: 3, mb: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            Aviso de Privacidad
          </Typography>

          <Typography component="p" paragraph>
            BANAS, (en adelante “la Aplicación”), es responsable del tratamiento de los datos personales que se recaban de sus usuarios, de conformidad con lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y demás normatividad aplicable en los Estados Unidos Mexicanos.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            1. Datos Personales Recabados
          </Typography>
          <Typography component="p" paragraph>
            La Aplicación recaba datos personales de identificación, contacto y, en su caso, datos sensibles relacionados con información clínica, de salud, antecedentes médicos y cualquier otro necesario para la adecuada prestación de los servicios ofrecidos.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            2. Finalidades del Tratamiento
          </Typography>
          <Typography component="p" paragraph>
            Los datos personales serán utilizados para las siguientes finalidades:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mt: 0, mb: 2 }}>
            <Typography component="li" paragraph>
              Brindar los servicios de registro, seguimiento y análisis clínico.
            </Typography>
            <Typography component="li" paragraph>
              Elaborar reportes médicos y dar seguimiento a la evolución de pacientes.
            </Typography>
            <Typography component="li" paragraph>
              Cumplir con obligaciones legales aplicables.
            </Typography>
            <Typography component="li" paragraph>
              Fines estadísticos y de mejora de la Aplicación (datos disociados cuando sea posible).
            </Typography>
          </Box>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            3. Transferencia de Datos
          </Typography>
          <Typography component="p" paragraph>
            Los datos personales podrán ser compartidos con autoridades competentes cuando sea legalmente requerido, así como con terceros proveedores de servicios que apoyen en las operaciones de la Aplicación, bajo las medidas de seguridad y confidencialidad pertinentes.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            4. Medidas de Seguridad
          </Typography>
          <Typography component="p" paragraph>
            La Aplicación implementa medidas de seguridad administrativas, técnicas y físicas que permiten proteger los datos personales contra daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizado.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            5. Derechos ARCO
          </Typography>
          <Typography component="p" paragraph>
            Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse (ARCO) al tratamiento de sus datos personales. Para ejercer estos derechos, envíe una solicitud al correo electrónico [correo@empresa.com] indicando su nombre completo, descripción clara de la solicitud y copia de una identificación oficial vigente.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="bold" gutterBottom>
            6. Cambios al Aviso de Privacidad
          </Typography>
          <Typography component="p" paragraph>
            Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones a este Aviso de Privacidad, las cuales estarán disponibles en la Aplicación o serán enviadas al correo electrónico que nos haya proporcionado.
          </Typography>

          <Typography component="p" paragraph>
            Autorizo de manera libre, voluntaria e informada el uso de la información obtenida a través de las evaluaciones psicológicas y neuropsicológicas que me han sido aplicadas, con el propósito exclusivo de análisis clínico, diagnóstico, seguimiento o investigación académica. Se me ha informado que los resultados serán tratados con estricta confidencialidad y utilizados únicamente por profesionales calificados, garantizando que mi identidad no será divulgada en ningún momento. Comprendo que puedo retirar mi consentimiento en cualquier momento.
          </Typography>
          <Typography component="p" paragraph>
            Al hacer uso de la Aplicación, usted acepta los términos del presente Aviso de Privacidad.
          </Typography>

          <Box component="hr" sx={{ border: 'none', borderTop: '1px solid #ddd', my: 2 }} />

          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            onClick={handleAccept}
            sx={{ mt: 3 }}
          >
            Acepto y continuar
          </Button>
        </Paper>
      </Box>
    </div>
  );
}

export default PrivacyPolicy;
